import {
  POPUP,
  PopupDefinition,
  LayoutComicsDefinition,
  LAYOUT_LIST,
  LAYOUT_COMICS,
  LayoutListDefinition,
  IMAGE_MAP2,
  AUDIO_POPUP,
  AudioPopupDefinition
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';
import { usableHotspotImageSize } from './interactive4Overlap';
import { ItemOfType } from './itemHelpers/types';

export const Interactive31: Translator = sequence => {
  const ITEMS: LayoutListDefinition[] = [];
  const background = sequence.items?.find(
    item => item.__typename === 'Background' || item.type === 'BACKGROUND'
  ) as ItemOfType<'Background'> | undefined;
  const backgroundPicture = background?.pictures?.[0];

  const ELEMENTS_COUNT = sequence.items!.filter(
    item => item.__typename === 'ImageMap'
  ).length;
  const isTriple: boolean = ELEMENTS_COUNT > 2;
  let count = 0;

  const getHeight = (count: number) =>
    isTriple && count > 0 ? '200px' : '420px';

  let imageDimensions: { width: number; height: number };

  let counterForButtonIcon = 0;

  const root = translate(sequence, item => {
    switch (item.__typename) {
      case 'ImageMap': {
        const mapWidth = Number(item.pictures?.[0]?.width);
        const mapHeight = Number(item.pictures?.[0]?.height);
        const hasKnownMapSize =
          Number.isFinite(mapWidth) &&
          mapWidth > 0 &&
          Number.isFinite(mapHeight) &&
          mapHeight > 0;
        // Preserve historical tiny-image bases; only unknown sizes use the writer's fallback.
        imageDimensions = hasKnownMapSize
          ? { width: mapWidth, height: mapHeight }
          : (usableHotspotImageSize(
              Number(item.pictures?.[0]?.width ?? backgroundPicture?.width),
              Number(item.pictures?.[0]?.height ?? backgroundPicture?.height)
            ) ?? { width: 1024, height: 1024 });

        ITEMS.push({
          id: `LAYOUT_LIST-${item.id}`,
          type: LAYOUT_LIST,
          values: { align: 'center' },
          items: [
            {
              type: IMAGE_MAP2,
              id: item.id,
              values: {
                imageUrl: item.pictures?.[0]?.mediaUrl,
                w: '100%',
                h: getHeight(count)
              },
              items: (item.items || []).map((i, index) => {
                const initialParts = (i.coordinates || '').split(',');
                const parts: string[] = [
                  (
                    (Number(initialParts[0]) * 100) /
                    imageDimensions.width
                  ).toString(),
                  (
                    (Number(initialParts[1]) * 100) /
                    imageDimensions.height
                  ).toString()
                ];

                if (item.variant == 'number') {
                  counterForButtonIcon = counterForButtonIcon + 1;
                }

                const btnTitle =
                  item.variant === 'number' ? counterForButtonIcon : '+';

                if (i.audios) {
                  return {
                    type: AUDIO_POPUP,
                    id: `${item.id}-${index}`,
                    items: [],
                    values: {
                      title: btnTitle,
                      left: parts[0] && parseInt(parts[0]),
                      top: parts[1] && parseInt(parts[1]),
                      name: i.title,
                      subtitle: i.subtitle,
                      body: i.body,
                      metric: '%',
                      isPopupCentered: true,
                      mediaUrl: i.audios?.[0]?.mediaUrl,
                      subtitlesUrl: i.audios?.[0]?.subtitlesUrl,
                      blocking: true,
                      replay: true,
                      btnSize: 85
                    }
                  } as AudioPopupDefinition;
                } else {
                  return {
                    type: POPUP,
                    id: `${item.id}-${index}`,
                    values: {
                      btnTitle: btnTitle,
                      left: parts[0] && parseInt(parts[0]),
                      top: parts[1] && parseInt(parts[1]),
                      title: i.title,
                      subtitle: i.subtitle,
                      body: i.body,
                      metric: '%',
                      isPopupCentered: true,
                      btnSize: 85,
                      blocking: true
                    }
                  } as PopupDefinition;
                }
              })
            }
          ]
        });
        count++;
        break;
      }
    }
    return null;
  });

  root.items.push({
    type: LAYOUT_COMICS,
    id: `${sequence.id}-columns`,
    items: ITEMS,
    values: {
      variant: isTriple ? 'triple' : 'double'
    }
  } as LayoutComicsDefinition);

  return root;
};
